import { useMutation } from 'react-query';
import { axiosInstance } from '../../../libs/axiosConfig';
import type { ApiResponse } from '../../../util/types/Response';
import type { UserDto } from '../types/UserDto';
import type { LoginDto } from '../types/LoginDto';

async function postLogin(login: LoginDto) {
	return await axiosInstance
		.post('/auth/login', login)
		.then((res) => res.data as ApiResponse<UserDto>);
}

export const mutateLogin = (login: LoginDto) => {
	return useMutation({
		mutationKey: ['login'],
		mutationFn: async () => {
			const data = await postLogin(login);

			return data;
		},
	});
};
